import {
  // DIGITAL ART
  ADD_SELLITEM,
  ADD_SELLITEM_SUCCESS,
  ADD_SELLITEM_FAIL,
  GET_ALL_SELLITEM,
  GET_ALL_SELLITEM_SUCCESS,
  GET_ALL_SELLITEM_FAIL,
  GET_PARTICULAR_SELLITEM,
  GET_PARTICULAR_SELLITEM_SUCCESS,
  GET_PARTICULAR_SELLITEM_FAIL,
  UPDATE_PARTICULAR_SELLITEM,
  UPDATE_PARTICULAR_SELLITEM_SUCCESS,
  UPDATE_PARTICULAR_SELLITEM_FAIL,
  SELLITEM_FROM_COLLECTION_ID,
  SELLITEM_FROM_COLLECTION_ID_SUCCESS,
  SELLITEM_FROM_COLLECTION_ID_FAIL,
  LIKE_VIEW_SELLITEM,
  LIKE_VIEW_SELLITEM_SUCCESS,
  LIKE_VIEW_SELLITEM_FAIL,
  ALL_SELLITEM_FROM_COLLECTION_ID,
  ALL_SELLITEM_FROM_COLLECTION_ID_SUCCESS,
  ALL_SELLITEM_FROM_COLLECTION_ID_FAIL,
  ALL_SELLITEM_NFT_COUNT,
  ALL_SELLITEM_NFT_COUNT_SUCCESS,
  ALL_SELLITEM_NFT_COUNT_ID_FAIL,
  SELL_ITEM_CURRENT_OWNER,
  SELL_ITEM_CURRENT_OWNER_SUCCESS,
  SELL_ITEM_CURRENT_OWNER_FAIL,
  TOP_SELL_ITEM,
  TOP_SELL_ITEM_SUCCESS,
  TOP_SELL_ITEM_FAIL,
  TRENDING_ARTWORK,
  TRENDING_ARTWORK_SUCCESS,
  TRENDING_ARTWORK_FAIL,
  GET_RECENT_LISTING,
  GET_RECENT_LISTING_SUCCESS,
  GET_RECENT_LISTING_FAIL,
  GET_EXPLORE_LISTING,
  GET_EXPLORE_LISTING_SUCCESS,
  GET_EXPLORE_LISTING_FAIL,
  GET_CANVAS_PAPER_SIZE,
  GET_CANVAS_PAPER_SIZE_SUCCESS,
  GET_CANVAS_PAPER_SIZE_FAIL,
} from "./actionTypes";

// ========================= DIGITAL ART ACTIONS =========================

export const getParticularSellItem = (id, callback) => ({
  type: GET_PARTICULAR_SELLITEM,
  payload: { id, callback },
});
export const getParticularSellItemSuccess = (data) => ({
  type: GET_PARTICULAR_SELLITEM_SUCCESS,
  payload: data,
});
export const getParticularSellItemFail = (error) => ({
  type: GET_PARTICULAR_SELLITEM_FAIL,
  payload: error,
});

export const getAllSellItem = (data, callback) => ({
  type: GET_ALL_SELLITEM,
  payload: { data, callback },
});
export const getAllSellItemSuccess = (data) => ({
  type: GET_ALL_SELLITEM_SUCCESS,
  payload: data,
});
export const getAllSellItemFail = (error) => ({
  type: GET_ALL_SELLITEM_FAIL,
  payload: error,
});

export const addSellItem = (data, callback) => ({
  type: ADD_SELLITEM,
  payload: { data, callback },
});
export const addSellItemSuccess = (data) => ({
  type: ADD_SELLITEM_SUCCESS,
  payload: data,
});
export const addSellItemFail = (error) => ({
  type: ADD_SELLITEM_FAIL,
  payload: error,
});

export const updateSellItem = (data, callback) => ({
  type: UPDATE_PARTICULAR_SELLITEM,
  payload: { data, callback },
});
export const updateSellItemSuccess = (data) => ({
  type: UPDATE_PARTICULAR_SELLITEM_SUCCESS,
  payload: data,
});
export const updateSellItemFail = (error) => ({
  type: UPDATE_PARTICULAR_SELLITEM_FAIL,
  payload: error,
});

export const sellItemFromCollectionId = (id, callback) => ({
  type: SELLITEM_FROM_COLLECTION_ID,
  payload: { id, callback },
});
export const sellItemFromCollectionIdSuccess = (data) => ({
  type: SELLITEM_FROM_COLLECTION_ID_SUCCESS,
  payload: data,
});
export const sellItemFromCollectionIdFail = (error) => ({
  type: SELLITEM_FROM_COLLECTION_ID_FAIL,
  payload: error,
});

export const likeViewSellItem = (data, callback) => ({
  type: LIKE_VIEW_SELLITEM,
  payload: { data, callback },
});
export const likeViewSellItemSuccess = (data) => ({
  type: LIKE_VIEW_SELLITEM_SUCCESS,
  payload: data,
});
export const likeViewSellItemFail = (error) => ({
  type: LIKE_VIEW_SELLITEM_FAIL,
  payload: error,
});

export const allsellItemFromCollectionId = (data, callback) => ({
  type: ALL_SELLITEM_FROM_COLLECTION_ID,
  payload: { data, callback },
});
export const allsellItemFromCollectionIdSuccess = (data) => ({
  type: ALL_SELLITEM_FROM_COLLECTION_ID_SUCCESS,
  payload: data,
});
export const allsellItemFromCollectionIdFail = (error) => ({
  type: ALL_SELLITEM_FROM_COLLECTION_ID_FAIL,
  payload: error,
});

export const allsellItemNFtCount = (data, callback) => ({
  type: ALL_SELLITEM_NFT_COUNT,
  payload: { data, callback },
});
export const allsellItemNFtCountSuccess = (data) => ({
  type: ALL_SELLITEM_NFT_COUNT_SUCCESS,
  payload: data,
});
export const allsellItemNFtCountFail = (error) => ({
  type: ALL_SELLITEM_NFT_COUNT_ID_FAIL,
  payload: error,
});

export const sellItemsCurrentOwner = (data, callback) => ({
  type: SELL_ITEM_CURRENT_OWNER,
  payload: { data, callback },
});
export const sellItemsCurrentOwnerSuccess = (data) => ({
  type: SELL_ITEM_CURRENT_OWNER_SUCCESS,
  payload: data,
});
export const sellItemsCurrentOwnerFail = (error) => ({
  type: SELL_ITEM_CURRENT_OWNER_FAIL,
  payload: error,
});

export const topSellItems = (data, callback) => ({
  type: TOP_SELL_ITEM,
  payload: { data, callback },
});
export const topSellItemsSuccess = (data) => ({
  type: TOP_SELL_ITEM_SUCCESS,
  payload: data,
});
export const topSellItemsFail = (error) => ({
  type: TOP_SELL_ITEM_FAIL,
  payload: error,
});

export const trendingArtWork = (data, callback) => ({
  type: TRENDING_ARTWORK,
  payload: { data, callback },
});
export const trendingArtWorkSuccess = (data) => ({
  type: TRENDING_ARTWORK_SUCCESS,
  payload: data,
});
export const trendingArtWorkFail = (error) => ({
  type: TRENDING_ARTWORK_FAIL,
  payload: error,
});

export const getrecentListing = (data, callback) => ({
  type: GET_RECENT_LISTING,
  payload: { data, callback },
});
export const getrecentListingSuccess = (data) => ({
  type: GET_RECENT_LISTING_SUCCESS,
  payload: data,
});
export const getrecentListingFail = (error) => ({
  type: GET_RECENT_LISTING_FAIL,
  payload: error,
});

export const getexploreListing = (data, callback) => ({
  type: GET_EXPLORE_LISTING,
  payload: { data, callback },
});
export const getexploreListingSuccess = (data) => ({
  type: GET_EXPLORE_LISTING_SUCCESS,
  payload: data,
});
export const getexploreListingFail = (error) => ({
  type: GET_EXPLORE_LISTING_FAIL,
  payload: error,
});

export const getCanvasPaperSize = (data, callback) => ({
  type: GET_CANVAS_PAPER_SIZE,
  payload: { data, callback },
});
export const getCanvasPaperSizeSuccess = (data) => ({
  type: GET_CANVAS_PAPER_SIZE_SUCCESS,
  payload: data,
});
export const getCanvasPaperSizeFail = (error) => ({
  type: GET_CANVAS_PAPER_SIZE_FAIL,
  payload: error,
});
